<template>
  <header class="bg-white shadow w-full rounded-t-xl">
    <div class="container mx-auto px-4 h-16 flex items-center justify-between">
      <div class="text-xl font-semibold text-gray-800">Graha Sumber Prima Elektronik, PT</div>
      <div class="relative">
        <button @click="toggleProfileMenu" class="focus:outline-none flex items-center">
          <UserCircleIcon class="rounded-full h-8 w-8 mr-2 text-gray-600" />
          <span class="text-gray-700">{{ username }}</span>
        </button>
        <div v-if="showProfileMenu" class="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10">
          <a href="#" class="block px-4 py-2 text-gray-800 hover:bg-gray-200">Profile</a>
          <a href="#" class="block px-4 py-2 text-gray-800 hover:bg-gray-200" @click.prevent="logout">Logout</a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { UserCircleIcon } from '@heroicons/vue/24/solid';

export default {
  name: 'NavbarPage',
  components: {
    UserCircleIcon,
  },
  data() {
    return {
      showProfileMenu: false,
      username: 'User', // Nilai default
    };
  },
  methods: {
    logout() {
      localStorage.removeItem('token');
      this.$router.push('/login');
    },
    toggleProfileMenu() {
      this.showProfileMenu = !this.showProfileMenu;
    },
  },
  // Lifecycle hook 'created' akan berjalan saat komponen dibuat
  created() {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        // 1. Ambil bagian payload dari token (bagian tengah)
        const payloadBase64 = token.split('.')[1];
        // 2. Decode dari Base64 ke string JSON
        const decodedPayload = atob(payloadBase64);
        // 3. Parse string JSON menjadi objek
        const payload = JSON.parse(decodedPayload);

        // 4. Ambil nama pengguna dari properti 'sub' (subject)
        // Jika ada, gunakan. Jika tidak, tetap 'User'.
        this.username = payload.sub || 'User';
      } catch (error) {
        console.error('Gagal mendekode token:', error);
        // Jika token tidak valid, biarkan nama pengguna default
        this.username = 'User';
      }
    }
  },
};
</script>